// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* * * * * * * * * * * * * * *\n\t\tdisplay sizes\n* * * * * * * * * * * * * * */\n/* * * * * * * * * * * * * * *\n\t\tsizes\n* * * * * * * * * * * * * * */\n/* * * * * * * * * * * * * * *\n\t\tcolors\n* * * * * * * * * * * * * * */\n/* fonts */\n/* borders */\n/* rest */\n/* new colors */\n.text-to-speech__TextToSpeech_23mOl {\n  border: 1px solid;\n  padding: 20px;\n}\n.text-to-speech__TextToSpeech_23mOl p {\n  font-size: 12px;\n}\n.text-to-speech__TextToSpeech_23mOl p a {\n  color: #25aae1;\n}\n", ""]);
// Exports
exports.locals = {
	"text-to-speech": "text-to-speech__TextToSpeech_23mOl",
	"textToSpeech": "text-to-speech__TextToSpeech_23mOl"
};
module.exports = exports;
